export function scrollTo(x: number, y: number): void {
    if (!isSSR) {
        window.scrollTo(x, y);
    }
}
